import React from 'react';

const Error = ({ type, message }) => {
    return (
        <div>
            <div style={{ display: "flex", flexDirection: "column" }}>
                <div>
                    Oops!
                </div>
                <div>
                    An unexpected error occurred:
                </div>
                <div>
                    {message}
                </div>
                <div style={{fontsize: "8pt", color: "#ccc"}}>
                    If this problem persists please contact our support.
                </div>
            </div>
        </div>
    );
};

export default Error;
